/**
 * Created by saeed on 12/29/2016.
 */

export class UserVM {
  id:number;
  login:string;
  firstName:string;
  lastName:string;
  email:string;
  activated:boolean;
  langKey:string;
  authorities:string[];
  phoneNumber:string;
  activationCode:string;
  password:string;
  verificationCode:string;
  registerStep;
  nationalCode:String;
  birthDate:Date;


  constructor() {
    this.activated = false;
    this.langKey = 'en';
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/models/UserVM.ts